import { Button } from "nq-component";
import CardView from "../../../../components/common/CardView";
import { FloatingForm } from "../../../../components/common/Converter";
import Hierarchy from "../../../../components/common/Hierarchy";

export function ViewOrganizationalStructure({ employee, handleCancel }) {
  return (
    <FloatingForm width="75rem">
      <CardView style={{ padding: 0 }}>
        <div className="row p-4">
          <h4>Organizational Structure</h4>
          <hr />
          {/* <p style={{ fontSize: "13px", padding: "1rem" }}>
           Click confirm to proceed.
         </p> */}
          <Hierarchy
            className="col-lg-6 p-2 mb-2"
            object={employee}
            disabled={true}
            handleObjectChange={() => console.log("")}
          />
          <hr />
          <br></br>
          <div className="w-100 d-flex justify-content-end gap-2 mb-2 pe-3">
            <Button className="btn btn-light" onClick={() => handleCancel()}>
              Cancel
            </Button>
          </div>
        </div>
      </CardView>
    </FloatingForm>
  );
}
